import buttonGroupStyle from "assets/jss/material-dashboard-pro-react/buttonGroupStyle.jsx";
import customCheckboxRadioSwitch from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx";
import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";

const extendedTablesStyle = {
  ...customCheckboxRadioSwitch,
  ...buttonGroupStyle,
  right: {
    textAlign: "right"
  },
  center: {
    textAlign: "center"
  },
  description: {
    maxWidth: "150px"
  },
  actionButton: {
    margin: "0 0 0 5px",
    padding: "5px",
    "& svg,& .fab,& .fas,& .far,& .fal,& .material-icons": {
      marginRight: "0px"
    }
  },
  icon: {
    verticalAlign: "middle",
    width: "17px",
    height: "17px",
    top: "-1px",
    position: "relative"
  },
  imgContainer: {
    width: "120px",
    maxHeight: "160px",
    overflow: "hidden",
    display: "block"
  },
  img: {
    width: "100%",
    height: "auto",
    verticalAlign: "middle",
    border: "0"
  },
  tdName: {
    minWidth: "200px",
    fontWeight: "400",
    fontSize: "1.5em"
  },
  tdNameAnchor: {
    color: "#3C4858"
  },
  tdNameSmall: {
    color: "#999999",
    fontSize: "0.75em",
    fontWeight: "300"
  },
  tdNumber: {
    textAlign: "right",
    minWidth: "145px",
    fontWeight: "300",
    fontSize: "1.3em !important"
  },
  tdNumberSmall: {
    marginRight: "3px"
  },
  tdNumberAndButtonGroup: {
    lineHeight: "1 !important"
  },
  positionAbsolute: {
    position: "absolute",
    right: "0",
    top: "0"
  },
  customFont: {
    fontSize: "16px !important"
  },
  actionButtonRound: {
    width: "auto",
    height: "auto",
    minWidth: "auto"
  },
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  contentContainer: {
    backgroundColor: "#fff",
    marginTop: "16px",
    borderRadius: "8px",
    padding: "16px 32px",
    boxShadow: "rgba(0,0,0,.1) 0px 2px 8px",
    position: "relative",
  },
  table: {
    margin: "24px -15px"
  },
  tbl: {
    margin: "0 -24px",
    fontSize: 13,
    "& .rt-table .rt-td": {
      padding: 0
    },
    "& .rt-table .rt-thead .rt-th": {
      padding: 0
    },
    "& .rt-table .rt-tbody .rt-tr-group": {
      justifyContent: 'center',
      position: 'relative',
      borderBottom: '2px solid white',
      lineHeight: 1,
      '&:hover a': {
          textDecoration: 'underline'
      }
    },
    "& .actions-right button": {
      margin: 0
    },
    "& .rt-noData": {
      fontSize: '1rem',
      fontWeight: 500,
      fontStyle: 'italic',
      top: '62%',
      color: 'rgba(0, 0, 0, 0.6)'
    }
  },
  title: {
    padding: 0,
    margin: 0,
    "& span": {
      "@media (min-width: 1200px)": {
        display: "none"
      }
    }
  },
  groupActions: {
    position: 'sticky',
    top: 70,
    backgroundColor: 'white',
    borderRadius: 8,
    display: 'flex',
    zIndex: 5
  },
  userInfoDetail: {
    cursor: "pointer",
    color: "black",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 300,
    lineHeight: "1.5em",
    fontSize: "15px",
    padding: 0,
    textTransform: "none",
    "&:hover span:last-child": {
      color: "#217DB2",
      textDecoration: "underline"
    }
  },
  loteActionsAnimation: {
    transition: "all .3s ease"
  },
  showLote: {
    opacity: 1,
  },
  hideLote: {
    opacity: 0,
    height: 0,
    overflow: 'hidden'
  },
  hideFilters: {
    opacity: 0,
    maxHeight: 0,
    overflow: 'hidden'
  },
  showFilters: {
    opacity: 1,
    maxHeight: 300
  },
  showLoteAds: {
    opacity: 1,
    height: 'auto',
    "@media (min-width: 1200px)": {
      height: 134.5667
    }
  },
  showPaidAdFilters:{
    opacity: 1,
  },
  adAuto: {
    backgroundColor: '#ffb500',
    padding: '0 4px',
    color: 'white',
    fontWeight: 'bold',
    marginRight: '8px',
    fontSize: '8pt',
    borderRadius: '4px',
    lineHeight: '1.6',
  },
  adTitleContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    padding: '6px 0',
  },
  adTitle: {
    whiteSpace: 'normal',
    margin: 0,
  },
  paidAdFrequencies: {
    color: 'black',
    fontWeight: 400,
    whiteSpace: 'normal',
    fontSize: 15
  },
  adImage: {
    width: '50px',
    height: '50px',
    marginRight: '8px',
    objectFit: 'contain'
  },
  adBtns: {
    padding: 0,
    fontSize: '15px',
    lineHeight: '20px',
    fontWeight: 400,
    display: 'block',
    color: "#217DB2",
    textAlign: 'left',
    textTransform: "none",
    textDecoration: "underline",
    transition: 'all .2s ease',
    "&:hover": {
      color: "black !important",
      backgroundColor: 'transparent !important',
      '& img': {
        border: '3px solid #217DB2'
      }
    }
  },
  adDetailsBtns: {
    fontSize: '13px',
    fontWeight: 400,
    display: 'block',
    color: "#217DB2",
    textAlign: 'left',
    textTransform: "none",
    textDecoration: "underline",
    transition: 'all .2s ease',
    "&:hover": {
      color: "black !important",
      '& img': {
        border: '3px solid #217DB2'
      }
    }
  },
  titleBtn: {
    textDecoration: 'none',
    color: 'black !important',
    paddingRight: 10,
    fontWeight: 400,
    whiteSpace: 'normal',
    lineHeight: 1.2,
    marginTop: 3,
    '&:hover': {
      color: '#217DB2 !important',
      '& p': {
        color: '#217DB2 !important',
      }
    },
    '&.title': {
      fontSize: 16,
    }
  },
  adCatBread: {
    padding: 0,
    margin: '4px 0 0',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    listStyle: 'none',
    fontWeight: 500,
    fontSize: 14,
    color: 'darkslateblue',
    width: '100%',
    '& li:last-child>button': {
      margin: 0
    },
    "& button": {
      padding: 0,
      fontSize: '14px',
      textTransform: 'none'
    },
    lineHeight: 1
  },
  adIconBread: {
    height: '15px',
    '& svg': {
      width: '15px',
      height: '15px'
    }
  },
  reviewCheck: {
    alignItems: 'flex-start',
    '&>span:first-child': {
      color: 'green',
      width: '100%',
    },
    '& button': {
      margin: 0
    },
    '& span': {
      display: 'flex',
      alignItems: 'center',
      lineHeight: 1,
      '& svg': {
        width: '0.8em',
        marginRight: 4
      }
    }
  },
  adUserContainer: {
    paddingLeft: 8,
    '& p': {
      margin: 0,
      fontWeight: 'bolder'
    }
  },
  adModalConfirmation: {
    '& h2': {
      fontSize: '18px'
    },
    textAlign: 'left'
  },
  adModalBtnsSection: {
    margin: '24px 8px 13px',
    display: 'flex',
    justifyContent: 'space-between'
  },
  adModalDesc: {
    backgroundColor: 'aliceblue',
    padding: '8px 16px',
    marginBottom: '8px',
    borderRadius: '8px',
    '& p': {
      margin: 0,
      overflowWrap: 'break-word',
      textAlign: 'left'
    }
  },
  switchChecked: {
    "& + $switchBar": {
      backgroundColor: "#00ae63 !important"
    }
  },
  switchBar: {
    width: '52px',
    height: '26px',
    marginTop: '-13px',
    borderRadius: '20px',
    marginLeft: '-27px',
    backgroundColor: '#b7bdbf',
    opacity: '1 !important',
  },
  switchIcon: {
    border: 'none',
    backgroundColor: 'white',
    width: '23px',
    height: '23px',
    transform: 'translateX(-7px)'
  },
  switchIconChecked: {
    transform: 'translateX(4px)'
  },
  loading: {
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    zIndex: 1,
    backgroundColor: 'rgba(255, 255, 255, .9)'
  },
  cellStatus: {
    textAlign: 'center',
    whiteSpace: 'normal',
  },
  deletedTag: {
    color: '#af223a'
  },
  pendingTag: {
    color: '#ffb500',
    whiteSpace: 'normal',
  },
  scheduledTag: {
    color: '#ff7f11'
  },
  runningTag: {
    color: '#23AD68'
  },
  completedTag: {
    color: '#217DB2'
  },
  unknownTag: {
    color: '#505052'
  },
  searchBtn: {
    '& svg': {
      color: '#217DB2'
    },
  },
  searchFieldContainer: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 13,
    fontWeight: 500,
  },
  filterBtn: {
    width: 50,
    "@media (min-width: 460px)": {
      width: 'auto',
    },
    '&>span>span': {
      display: "none",
      "@media (min-width: 460px)": {
        display: 'inherit',
      }
    }
  },
  btnUserRead: {
    padding: 0,
    color: '#000',
    '&:hover': {
      color: '#217DB2',
    },
    '& img': {
      width: 32,
      height: 32,
      borderRadius: '50%'
    },
    '& .agencyIco' : {
      width: 18,
      right: -7,
      height: 18,
      bottom: -10,
      position: 'absolute',
    }
  },
  btnAgencyRead: {
    padding: '0',
    color: '#000',
    '&:hover': {
      color: '#217DB2',
    },
    '& img': {
      width: 32,
      height: 32,
      borderRadius: '50%'
    },
  },
  anchorUserRead: {
    marginLeft: '8px',
    color: '#000',
    '&:hover': {
      color: '#217DB2',
    },
  },
  btnAgency: {
    padding: '0',
    color: '#000',
    '&:hover': {
      color: '#217DB2',
    },
    '& img': {
      width: 32,
      height: 32,
      borderRadius: '50%'
    },
  },
  btnRadar:{
    padding: '0',
    color: '#000',
    '&:hover': {
      color: '#217DB2',
    },
  },
  idAndDate: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    '& p': {
      marginBottom: 0,
      display: 'flex',
      alignItems: 'center',
      lineHeight: 1,
      fontWeight: 400,
      '& svg': {
        width: 15,
        height: 15,
        marginRight: 0,
      }
    }
  },
  modificationDate: {
    color: 'black',
    fontSize: 12,
    '& svg': {
      width: 14,
      margin: 0,
    },
    display: 'flex',
    alignItems: 'center',
    margin: 0
  },
  botScore: {
    display: 'flex',
    alignItems: `center`,
    color: 'black',
    fontSize: '14px',
    fontWeight: 500,
    '& svg': {
      width: 14,
      height: 15,
      margin: '0 2px 0 0',
    }
  },
  ipField: {
    color: 'black',
    fontSize: '14px',
    fontWeight: 500,
    textAlign: 'center'
  },
  headerField: {
    fontWeight: 500,
    fontSize: 15,
    '& p': {
      margin: 0
    }
  },
  sortField: {
    color: '#00abf5',
    fontSize: 15,
    fontWeight: 500,
    '&::after': {
      content: '""',
      backgroundColor: '#00abf5',
      width: 5,
      height: 5,
      borderRadius: '50%',
      display: 'inline-block',
      position: 'absolute',
      top: 12,
      opacity: 1
    }
  },
  arrow: {
    position: 'absolute',
    fontSize: 6,
    bottom: 0,
    left: 0,
    marginBottom: '-0.95em',
    width: '100%',
    height: '1em',
    '&::before': {
      content: '""',
      margin: 'auto',
      display: 'block',
      width: 0,
      height: 0,
      borderStyle: 'solid',
      borderWidth: '1em 1em 0 1em',
      borderColor: `#413636 transparent transparent transparent`,
    },
  },
  bootstrapPlacementTop: {
    margin: '8px 0',
  },
  bootstrapTooltip: {
    backgroundColor: '#413636',
    transform: 'translateY(10px)'
  },
  blockedUser: {
    color: 'gray',
    '& img': {
      opacity: .3
    }
  },
  dateFormat: {
    fontSize: '12px',
    fontWeight: 400,
    color: 'gray',
    justifyContent: 'center',
  },
  z1: {
    "z-index": 1
  },
  z2: {
    "z-index": 2
  },
  z3: {
    "z-index": 3
  },
  loadingLineContainer: {
    position: 'absolute',
    left: 0,
    width: '100%',
  },
  topLine: {
    extend: 'loadingLineContainer',
    top: 0,
  },
  bottomLine: {
    extend: 'loadingLineContainer',
    bottom: 0,
  },
  loadingLine: {
    backgroundColor: '#2DAAF2'
  },
  avatarContainer: {
    position: 'relative'
  },
  colAgencyDetails: {
    height: 40,
    display: 'flex',
    alignItems: 'center',
    padding: 0,
    margin: 0,
  },
  matchedRule: {
    '& h6': {
      margin: '2px 0 0'
    }
  },
  rowExpanded: {
    padding: 16,
    fontSize: 16,
    fontWeight:400,
    borderTop: '1px solid lightgray',
    paddingLeft: 60,
    '& .description': {
      margin: '16px 0',
      padding: '8px 16px',
      background: '#f7f7f7',
      overflowWrap: 'break-word',
      whiteSpace: 'normal',
      color: 'black'
    },
    '& .link': {
        fontSize: 14,
      textDecoration: 'underline',
    },
    '& .date': {
        display: 'inline-flex'
    }
  },
  scoreLink: {
    textDecoration: 'none',
    color: 'black !important',
    paddingRight: 10,
    fontWeight: 400,
    whiteSpace: 'normal',
    lineHeight: 1.2,
    '&:hover': {
      color: '#217DB2 !important',
      '& p': {
        color: '#217DB2 !important',
      }
    },
    '& .title': {
      fontSize: 16,
    }
  },
  onlyInfoRules: {
    textDecoration: 'none',
    color: 'black !important',
    paddingRight: 10,
    fontWeight: 400,
    whiteSpace: 'normal',
    lineHeight: 1.2,
    marginTop: 3,
    fontSize: 15,
  },
  infoStatusAndReview: {
    maxWidth:'10em',
    '& h6': {
      marginBottom: 0,
      marginTop: 0,
    }
  },
  ipRow: {
    padding: 16,
    fontSize: 16,
    fontWeight: 400,
  },
  paidAdDuration: {
    color: 'black',
    fontWeight: 400,
    whiteSpace: 'normal',
    fontSize: 15
  }
};

export default extendedTablesStyle;
